import { ZonedDate } from './date';

export const setZeroHours = (date: Date) => ZonedDate(date).setHours(23, 59, 0, 0);
